import { Navigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function ProtectedRoute({ children }) {
  const { t } = useTranslation();
  const { user, loading, isAuthenticated } = useAuth();
  const { isRejectedAll } = useCookieConsent();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(100vh - 170px)",
        }}
      >
        <Spin size="large" tip={t("common.messages.loading")} />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isRejectedAll) {
    return (
      <Navigate to="/cookie-settings" state={{ from: location }} replace />
    );
  }

  return children;
}
